/* istanbul ignore file */
import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  TextField,
} from '@material-ui/core';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { KeycloakUser } from 'containers/RecapManagerPage/typings';
import { get } from 'lodash';
import { DATE_FORMAT } from 'constants/global';
import {
  HOLDER_PV_PROVIDER,
  HOLDER_PV_LAWYER,
  HOLDER_PV_OTHER,
} from 'containers/RecapPage/canstants';
import moment from 'moment-timezone';
import frLocale from 'date-fns/locale/fr';
import { isEmpty, isNil, uniqueId } from 'lodash';
import { IntlShape, injectIntl } from 'react-intl';
import styled from 'styled-components';
import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { translate } from 'containers/services/translate';
import messages from 'containers/RecapPage/messages';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import DateFnsUtils from '@date-io/date-fns';
import { ITEM_KEYS, SAGIS_KEYS } from 'containers/RecapManagerPage/constants';
import { dateStringToLocalDate } from 'containers/IdentificationPage/utils';
import * as utils from 'containers/RecapManagerPage/utils';
import { SagisConfig } from 'containers/AppContainer/typings';
import { filterStackHolder } from 'services/utils';

const StyledDiv = styled.div`
  width: 576px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .select {
    width: 90%;
    margin-bottom: 33px;
    font-size: 13px;
  }
  .input {
    width: 90%;
    margin-bottom: 33px;
    font-size: 13px;
  }
`;
const StyledDialogActions = styled(DialogActions)`
  position: relative;
  padding: 20px 30px;
  display: flex;
  flex-direction: row;

  .primary-button {
    padding-left: 5px;
    color: #ffffff !important;
    border-color: #0075c9;
    background-color: #0075c9;
    &:hover {
      background-color: #0075c9;
      border: 1px solid #0075c9;
    }
    &:mui-disabled {
      color: #ffffff;
    }
  }

  .Mui-disabled {
    opacity: 0.6;
  }
`;

export interface ServiceProviderDialogProps {
  intl: IntlShape;
  open: boolean;
  onClose: Function;
  providers: any[];
  setProviderTo: Function;
  ConfirmAction: Function;
  providerTo: any;
  completionDate: any;
  setCompletionDate: Function;
  receptionDate: any;
  setReceptionDate: Function;
  lossDate: Date;
  listings: any;
  pvHolderType: any;
  setPvHolderType: Function;
  otherPvHolder: any;
  setOtherPvHolder: Function;
  corporealLawyers: KeycloakUser[];
  requestCorporealLawyers: Function;
  stackholderTypes: SagisConfig[];
  stackholders: SagisConfig[];
  firmReferenceLawyer: any;
  setFirmReferenceLawyer: Function;
}

const ServiceProviderDialog: React.FC<ServiceProviderDialogProps> = (
  props,
): JSX.Element => {
  const [isInputChanged, setIsInputChanged] = useState<boolean>(true);
  const [
    isInputChangedDateCompletion,
    setIsInputChangedDateCompletion,
  ] = useState<boolean>(true);
  const [stakeholders, setStakeholders] = React.useState([] as SagisConfig[]);

  const { onClose, open } = props;
  const inputLabel = React.useRef<HTMLLabelElement>(null);

  const handleChange = (
    event: React.ChangeEvent<{
      value: unknown;
      name?: string;
    }>,
  ) => {
    const { value } = event.target;
    props.setProviderTo(value);
  };
  useEffect(() => {
    props.requestCorporealLawyers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const _stackholders = utils.getListBySagisKey(
      props.stackholderTypes,
      props.stackholders,
      ITEM_KEYS.LAWYER,
      SAGIS_KEYS.ITEM_TYPE as keyof SagisConfig,
    );

    const lawyers = utils.getBawabaLawyers(
      _stackholders,
      props.corporealLawyers,
    );
    setStakeholders(lawyers);
  }, [props.stackholderTypes, props.stackholders, props.corporealLawyers]);

  const handleChangeType = (
    event: React.ChangeEvent<{
      value: unknown;
      name?: string;
    }>,
  ) => {
    const { value } = event.target;
    props.setPvHolderType(value);
    props.setCompletionDate(null);
    props.setReceptionDate(null);
    props.setOtherPvHolder(null);
    props.setFirmReferenceLawyer(null);
    props.setProviderTo(null);
  };
  const handleClose = () => {
    props.setProviderTo(null);
    onClose();
  };
  const handleChangeDate = (fieldName: string) => (date: any) => {
    if (fieldName === 'COMPLETION_DATE') {
      setIsInputChangedDateCompletion(!isInputChangedDateCompletion);
      props.setCompletionDate(date);
    } else {
      setIsInputChanged(!isInputChanged);
      props.setReceptionDate(date);
    }
  };
  const handleChangeOtherPvHolder = (
    event: React.ChangeEvent<{
      value: unknown;
      name?: string;
    }>,
  ) => {
    const { value } = event.target;
    props.setOtherPvHolder(value);
  };
  const handleChangeFirmReference = (
    event: React.ChangeEvent<{
      value: unknown;
      name?: string;
    }>,
  ) => {
    const { value } = event.target;
    props.setFirmReferenceLawyer(value);
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <DialogTitle id="simple-dialog-title">
        {translate({ ...messages.preOpeningManagerProviderDialogTitle }, props)}
      </DialogTitle>
      <DialogContent>
        <StyledDiv>
          <FormControl className="select">
            <InputLabel ref={inputLabel} id="demo-simple-select-outlined-label">
              {translate(messages.type, props)}
            </InputLabel>
            <Select
              value={props.pvHolderType}
              onChange={handleChangeType}
              labelWidth={60}
            >
              {!isEmpty(get(props.listings, 'pvHolderType', [])) &&
                get(props.listings, 'pvHolderType', []).map((val: any) => (
                  <MenuItem key={uniqueId('stackholder_')} value={val.id}>
                    {val.title}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          {props.pvHolderType != HOLDER_PV_OTHER && !isNil(props.pvHolderType) && (
            <FormControl className="select">
              <InputLabel
                ref={inputLabel}
                id="demo-simple-select-outlined-label"
              >
                {translate(
                  { ...messages.preOpeningManagerProviderDialogInput },
                  props,
                )}
              </InputLabel>
              <Select
                value={props.providerTo}
                onChange={handleChange}
                labelWidth={60}
              >
                {!isEmpty(props.providers) &&
                  (props.pvHolderType === HOLDER_PV_PROVIDER
                    ? props.providers
                    : filterStackHolder(stakeholders)
                  ).map((val: any) => (
                    <MenuItem
                      key={uniqueId('stackholder_')}
                      value={val.ItemKey}
                    >
                      {val.ItemDescription}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          )}

          <>
            {props.pvHolderType === HOLDER_PV_PROVIDER && (
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
                <KeyboardDatePicker
                  autoOk
                  disableFuture
                  variant="inline"
                  minDate={props.lossDate}
                  invalidDateMessage=""
                  format="dd/MM/yyyy"
                  id="completionDate"
                  onChange={handleChangeDate('COMPLETION_DATE')}
                  name={'COMPLETION_DATE'}
                  value={dateStringToLocalDate(props.completionDate)}
                  label={translate({ ...messages.dateCompletion }, props)}
                  className="input"
                  InputLabelProps={{
                    shrink: !!props.completionDate,
                    classes: { root: 'label-input' },
                  }}
                  error={
                    moment(new Date(props.completionDate)).format(DATE_FORMAT) <
                      moment(new Date(props.lossDate)).format(DATE_FORMAT) ||
                    new Date(props.completionDate) > new Date() ||
                    props.completionDate === '' ||
                    props.completionDate === null ||
                    moment(props.completionDate).format(DATE_FORMAT) ===
                      'Invalid date' ||
                    props.completionDate === 'Invalid Date'
                  }
                  helperText={
                    moment(new Date(props.completionDate)).format(DATE_FORMAT) <
                      moment(new Date(props.lossDate)).format(DATE_FORMAT) ||
                    new Date(props.completionDate) > new Date() ||
                    props.completionDate === '' ||
                    props.completionDate === null ||
                    moment(props.completionDate).format(DATE_FORMAT) ===
                      'Invalid date' ||
                    props.completionDate === 'Invalid Date'
                      ? translate(messages.dateCompletionError, props)
                      : ''
                  }
                />
              </MuiPickersUtilsProvider>
            )}
            {(props.pvHolderType === HOLDER_PV_PROVIDER ||
              props.pvHolderType === HOLDER_PV_LAWYER) && (
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
                <KeyboardDatePicker
                  autoOk
                  disableFuture
                  variant="inline"
                  invalidDateMessage=""
                  format="dd/MM/yyyy"
                  minDate={props.completionDate}
                  id="receptionDate"
                  onChange={handleChangeDate('RECEPTION_DATE')}
                  name={'RECEPTION_DATE'}
                  value={dateStringToLocalDate(props.receptionDate)}
                  label={translate({ ...messages.dateReception }, props)}
                  className="input"
                  InputLabelProps={{
                    shrink: !!props.receptionDate,
                    classes: { root: 'label-input' },
                  }}
                  error={
                    (props.pvHolderType === HOLDER_PV_PROVIDER &&
                      moment(new Date(props.receptionDate)).format(
                        DATE_FORMAT,
                      ) <
                        moment(new Date(props.completionDate)).format(
                          DATE_FORMAT,
                        )) ||
                    new Date(props.receptionDate) > new Date() ||
                    props.receptionDate === '' ||
                    props.receptionDate === null ||
                    moment(props.receptionDate).format(DATE_FORMAT) ===
                      'Invalid date' ||
                    props.receptionDate === 'Invalid Date'
                  }
                  helperText={
                    (props.pvHolderType === HOLDER_PV_PROVIDER &&
                      moment(new Date(props.receptionDate)).format(
                        DATE_FORMAT,
                      ) <
                        moment(new Date(props.completionDate)).format(
                          DATE_FORMAT,
                        )) ||
                    new Date(props.receptionDate) > new Date() ||
                    props.receptionDate === '' ||
                    props.receptionDate === null ||
                    moment(props.receptionDate).format(DATE_FORMAT) ===
                      'Invalid date' ||
                    props.receptionDate === 'Invalid Date'
                      ? props.pvHolderType === HOLDER_PV_LAWYER
                        ? translate(
                            messages.dateReceptionProviderLawyerError,
                            props,
                          )
                        : translate(messages.dateReceptionError, props)
                      : ''
                  }
                />
              </MuiPickersUtilsProvider>
            )}
          </>

          {props.pvHolderType === HOLDER_PV_OTHER && (
            <TextField
              onChange={handleChangeOtherPvHolder}
              name={'other'}
              className="input"
              value={props.otherPvHolder}
              label={translate(messages.otherTitle, props)}
              multiline
              fullWidth
              style={{ marginLeft: 10 }}
            />
          )}
          {props.pvHolderType === HOLDER_PV_LAWYER && (
            <TextField
              onChange={handleChangeFirmReference}
              name={'firm reference'}
              value={props.firmReferenceLawyer}
              label={translate(messages.firmReference, props)}
              className="input"
              multiline
              fullWidth
              style={{ marginLeft: 10 }}
            />
          )}
        </StyledDiv>
      </DialogContent>
      <StyledDialogActions>
        <SecondaryButton
          onClick={handleClose}
          disableElevation
          title={translate(
            { ...messages.preOpeningManagerProviderDialogCancelButton },
            props,
          )}
        />
        <PrimaryButton
          onClick={() => props.ConfirmAction()}
          disableElevation
          className="primary-button"
          disabled={
            isNil(props.pvHolderType) ||
            (props.pvHolderType === HOLDER_PV_PROVIDER &&
              (moment(new Date(props.receptionDate)).format(DATE_FORMAT) <
                moment(new Date(props.completionDate)).format(DATE_FORMAT) ||
                new Date(props.receptionDate) > new Date() ||
                props.completionDate === '' ||
                moment(props.completionDate).format(DATE_FORMAT) ===
                  'Invalid date' ||
                new Date(props.completionDate) === null ||
                moment(new Date(props.completionDate)).format(DATE_FORMAT) <
                  moment(new Date(props.lossDate)).format(DATE_FORMAT) ||
                new Date(props.completionDate) > new Date() ||
                props.receptionDate === '' ||
                props.receptionDate === null ||
                moment(props.receptionDate).format(DATE_FORMAT) ===
                  'Invalid date' ||
                props.receptionDate === 'Invalid Date')) ||
            (props.pvHolderType === HOLDER_PV_OTHER &&
              isNil(props.otherPvHolder)) ||
            (props.pvHolderType === HOLDER_PV_LAWYER &&
              isNil(props.providerTo)) ||
            (props.pvHolderType === HOLDER_PV_PROVIDER &&
              isNil(props.providerTo)) ||
            (props.pvHolderType === HOLDER_PV_LAWYER &&
              (new Date(props.receptionDate) > new Date() ||
                props.receptionDate === '' ||
                props.receptionDate === null ||
                moment(props.receptionDate).format(DATE_FORMAT) ===
                  'Invalid date' ||
                props.receptionDate === 'Invalid Date'))
          }
          title={translate(
            { ...messages.preOpeningManagerProviderDialogValidationButton },
            props,
          )}
        />
      </StyledDialogActions>
    </Dialog>
  );
};

ServiceProviderDialog.defaultProps = {
  open: false,
};

export default injectIntl(ServiceProviderDialog);
